import { NavLink } from "react-router-dom";
import { User } from "../services/user/userModel";
import { useTranslation } from "react-i18next";
import LanguageSwitcher from "./LanguageSwitcher";

// Pied de page clair de la maquette v3. Connecté, on choisit la langue dans l'en-tête (CommonHeader,
// shell/ProTopbar) ; les pages publiques (connexion, inscription…) n'ont pas d'en-tête : elle reste ici.
const CommonFooter = ({ loggedUser }: { loggedUser?: User }) => {
  const { t } = useTranslation(["common", "links"]);
  return (
    <footer className="footer">
      {
        //TODO: Replace links with 2min-max document links
      }
      <a
        className="link"
        href="https://www.2minutesmax.com/"
        target="_blank"
        rel="noreferrer"
      >
        {t("common:footer.WHO_ARE_WE")}
      </a>
      <a
        className="link"
        href={t("links:LEGAL_NOTICE")}
        target="_blank"
        rel="noreferrer"
      >
        {t("common:footer.LEGAL_NOTICE")}
      </a>
      <a
        className="link"
        href={t("links:TERMS_AND_CONDITIONS")}
        target="_blank"
        rel="noreferrer"
      >
        {t("common:footer.CGV_CGU")}
      </a>
      <NavLink
        className="link"
        to={
          !loggedUser
            ? "/contact"
            : !loggedUser.organizationId
              ? "/candidate/contact"
              : "/organization/contact"
        }
      >
        {t("common:footer.CONTACT")}
      </NavLink>
      <span>{`© ${new Date().getFullYear()} 2 Minutes Max`}</span>
      {!loggedUser && <LanguageSwitcher />}
    </footer>
  );
};

export default CommonFooter;
